import type ProjectSectionType from 'src/enums/companyProjects/ProjectSectionType';

export const projectContainerQueryKeys = {
  table: () => ['projectContainerTable'] as const,
  tablePage: (
    page: number,
    rowsPerPage: number,
    orderBy: string | undefined,
    isDesc: boolean | undefined,
    filterModel: unknown
  ) => ['projectContainerTable', page, rowsPerPage, orderBy, isDesc, filterModel] as const,
  edit: (projectContainerId: number | undefined) => ['projectContainerEdit', projectContainerId] as const,
  section: (projectContainerId: number | undefined, sectionType: ProjectSectionType | undefined) =>
    ['projectContainerOverview', projectContainerId, 'section', sectionType] as const,
  homeFeedRoot: () => ['projectContainerHomeFeed'] as const,
  homeFeed: (projectContainerId: number | undefined) => ['projectContainerHomeFeed', projectContainerId] as const,
  folderIntakesRoot: () => ['projectFolderIntakes'] as const,
  folderIntakes: (folderId: number) => ['projectFolderIntakes', folderId] as const,
  containerIntakesRoot: (projectContainerId: number) => ['projectContainerIntakes', projectContainerId] as const,
  containerIntakes: (
    projectContainerId: number,
    filters: {
      search: string;
      folderId: number | null;
      sectionType: ProjectSectionType | null;
      unreadOnly: boolean;
    }
  ) => ['projectContainerIntakes', projectContainerId, filters] as const,
  intakeFolder: (intakeId: number | undefined) => ['projectIntakeFolder', intakeId] as const,
  assessment: (projectContainerId: number | undefined) => ['projectContainerAssessment', projectContainerId] as const
};
